// Frontend constants for structure prediction models
// Keep in sync with StructurePredictionModel in benchling/molbio/proteins/models/structure_prediction_run.py

import staticURL from 'lib/staticURL';

export enum StructurePredictionModel {
  ALPHAFOLD = 'alphafold',
  CHAI1 = 'chai1',
  BOLTZ2 = 'boltz2',
}

const STRUCTURE_PREDICTION_MODEL_DISPLAY_NAMES: {[model in StructurePredictionModel]: string} = {
  [StructurePredictionModel.ALPHAFOLD]: 'AlphaFold2',
  [StructurePredictionModel.CHAI1]: 'Chai-1',
  [StructurePredictionModel.BOLTZ2]: 'Boltz-2',
};

export const MODEL_EGRESSES_DATA: {[model in StructurePredictionModel]: boolean} = {
  [StructurePredictionModel.ALPHAFOLD]: false,
  [StructurePredictionModel.CHAI1]: false,
  [StructurePredictionModel.BOLTZ2]: false,
};

// allows controlled rollout of multi-protein structure predictions
export const MULTIMER_ENABLED_MODELS = [StructurePredictionModel.CHAI1, StructurePredictionModel.BOLTZ2];

/**
 * Get the user-friendly display name for a structure prediction model.
 * Falls back to the original model string if not found in the mapping.
 */
export function getModelDisplayName(model: string): string {
  return STRUCTURE_PREDICTION_MODEL_DISPLAY_NAMES[model as StructurePredictionModel] ?? model;
}

export const MAX_AMINO_ACID_COUNT = 1500;

// Maximum number of components allowed in a multimer prediction
// Keep in sync with MAX_MULTIMER_COMPONENTS in benchling/molbio/proteins/structure_prediction/constants.py
export const MAX_MULTIMER_COMPONENTS = 25;

// Keep in sync with MAX_CHAI1_TOKEN_COUNT in benchling/molbio/proteins/structure_prediction/constants.py
export const MAX_CHAI1_TOKEN_COUNT = 2048;

export enum StructurePredictionPreferences {
  HAS_DISMISSED_MODEL_CONFIDENCE_POPOVER = 'HAS_DISMISSED_MODEL_CONFIDENCE_POPOVER',
}

const MODEL_ICON_URLS: {[model in StructurePredictionModel]: string} = {
  [StructurePredictionModel.ALPHAFOLD]: staticURL('/static/img/model_hub/alphafold2.png'),
  [StructurePredictionModel.CHAI1]: staticURL('/static/img/model_hub/chai1.png'),
  [StructurePredictionModel.BOLTZ2]: staticURL('/static/img/model_hub/boltz2.png'),
};

export function getModelIconUrl(model: StructurePredictionModel): string {
  return MODEL_ICON_URLS[model] ?? staticURL(`/static/img/model_hub/${model}.png`);
}
